import React, {useState} from 'react';
import {ReactComponent as ArrowDownIco} from "../../../../../../../../images/icons/arrow-bottom.svg";
import {ReactComponent as ArrowUpIco} from "../../../../../../../../images/icons/arrow-top.svg";
import ProductModifierGroupQuantityInfo from "../ProductModifierGroupQuantityInfo";
import {Collapse} from "react-bootstrap";
import ProductModifierGroupSimpleOption from "./ProductModifierGroupSimpleOption";
import StateItemHelper from "../../../../../../../services/Menu/services/State/StateItemHelper";
import {connect} from "react-redux";
import {RootState} from "../../../../../../../../reducers";
import {getItems, getModifierGroups} from "../../../../../../../services/Menu/reducer";
import {getSession} from "../../../../../../../services/Session/reducer";
import {useTranslation, withTranslation} from "react-i18next";
import ProductModifierGroupsModal from "../ProductModifierGroupsModal";
import MenuEditItemViewHelper from "../../../../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";
import StoreUtils from "../../../../../../../services/Store/StoreUtils";
import {getStoreConfig} from "../../../../../../../services/Store/reducer";

interface OwnProps {
    modifierGroup: Record<string, any>;
    updateProductState: (productState: Record<string, any>) => void;
    productState: Record<string, any>;
    isProductAvailable: boolean;
    isProductASet: boolean;
    menuId?: number;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductModifierGroupSimple = ({
                                        modifierGroup,
                                        updateProductState,
                                        productState,
                                        items,
                                        modifierGroups,
                                        session,
                                        isProductAvailable,
                                        isProductASet,
                                        config,
                                        menuId
                                    }: Props) => {
    const [showItems, setShowItems] = useState(true);
    const selectedOptions = productState.modifier_groups.find((group: Record<string, any>) => group.modifier_group_id === modifierGroup.id)?.selected_items || [];
    const {t} = useTranslation();
    const [showModifierGroupsModal, setShowModifierGroupsModal] = useState(false);

    const changeOptionQuantity = (quantity: number, option: Record<string, any>) => {
        const newProductState = JSON.parse(JSON.stringify(productState));
        StateItemHelper.setQuantityItem(newProductState, modifierGroup, option, quantity, items, modifierGroups, session.order_type)
        updateProductState(newProductState);
    };

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.currentTarget.blur();
        setShowModifierGroupsModal(true)
    };

    const getAllSortedOptions = () => {
        return modifierGroup.options.filter((option: Record<string, any>) => option.max_permitted !== 0).sort((a: Record<string, any>, b: Record<string, any>) => a.position - b.position || a.name.localeCompare(b.name));
    }

    const getSortedSelectedOptions = () => {
        const sortedOptions = getAllSortedOptions();
        const order = sortedOptions.map((option: Record<string, any>) => option.id);

        return selectedOptions.map((option: Record<string, any>) => {
            const modifierGroupOption = MenuEditItemViewHelper.parseOptionForIncludedQuantity(modifierGroup.options
                .find((opt: Record<string, any>) => opt.id === option.item_id));
            return {
                ...option,
                modifierGroupOption,
            };
        })
            .filter((option: Record<string, any>) => !option.modifierGroupOption.only_included_and_cannot_modify && option.max_permitted !== 0)
            .sort((a: Record<string, any>, b: Record<string, any>) => order.indexOf(a.item_id) - order.indexOf(b.item_id));
    }

    const anySelectedOptions = getSortedSelectedOptions().length > 0;

    const showCollapseIcon = () => {
        if (isProductASet) return selectedOptions.length > 0;

        return true;
    }

    const drawOptions = () => {
        const optionsToDraw = isProductASet ? getSortedSelectedOptions() : getAllSortedOptions();

        return optionsToDraw
            .filter((option: Record<string, any>) => {
                const optionState = isProductASet ? option : option.state;
                const quantity = optionState?.quantity ?? 0;
                const modifierGroupOption = isProductASet ? option.modifierGroupOption : option;

                return !(modifierGroupOption.max_permitted && modifierGroupOption.max_permitted === quantity && modifierGroupOption.min_permitted && modifierGroupOption.min_permitted === quantity);

            })
            .map((option: Record<string, any>) => {
                const {modifierGroupOption} = option;
                const optionId = isProductASet ? option.item_id : option.id;

                return (
                    <div key={`${modifierGroup.id}-${optionId}`} aria-live="polite">
                        <ProductModifierGroupSimpleOption
                            modifierGroupOption={isProductASet ? modifierGroupOption : option}
                            modifierGroup={modifierGroup}
                            changeQuantity={changeOptionQuantity}
                            optionState={isProductASet ? option : option.state}
                            isProductAvailable={isProductAvailable}
                        />
                    </div>
                )
            })
    }

    const getButtonTitle = () => {
        if (StoreUtils.isOrderingReadonly(config)) return t("modules.menu.action.available_options.title");

        return anySelectedOptions ? t("modules.menu.action.change_choice.title") : t("common.action.choose");
    }

    if (!modifierGroup.adapted_max_permitted
        && modifierGroup.adapted_quantity >= modifierGroup.adapted_max_permitted) return <></>;

    return (
        <fieldset className="form-group">
            <legend aria-live="polite">
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <h5>
                        {modifierGroup.name}
                    </h5>
                    {showCollapseIcon() && (
                        showItems ? <ArrowUpIco className="collapse-icon" onClick={() => setShowItems(false)}/> :
                            <ArrowDownIco className="collapse-icon" onClick={() => setShowItems(true)}/>
                    )}
                </div>
                <ProductModifierGroupQuantityInfo
                    hideBadge={isProductAvailable ? undefined : true}
                    quantity={modifierGroup.adapted_quantity}
                    quantityInfo={{
                        minPermitted: modifierGroup.adapted_min_permitted,
                        maxPermitted: modifierGroup.adapted_max_permitted,
                        chargeAbove: modifierGroup.adapted_charge_above
                    }}/>
            </legend>
            <Collapse in={showItems}>
                <div>
                    <div className="d-flex flex-column gap-2">
                        {drawOptions()}
                        {isProductASet && (
                            <button className={`btn ${anySelectedOptions ? "btn-default" : "btn-primary"}`}
                                    disabled={!isProductAvailable}
                                    onClick={handleButtonClick}>
                                {getButtonTitle()}
                            </button>
                        )}
                    </div>
                </div>
            </Collapse>
            {
                showModifierGroupsModal && (
                    <ProductModifierGroupsModal show={showModifierGroupsModal}
                                                onHide={() => setShowModifierGroupsModal(false)}
                                                modifierGroupId={modifierGroup.id}
                                                updateProductState={updateProductState}
                                                productState={productState}
                                                menuId={menuId}/>
                )
            }
        </fieldset>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    modifierGroups: getModifierGroups(state.menu),
    session: getSession(state.session),
    config: getStoreConfig(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ProductModifierGroupSimple));